import BootstrapCurrentUser from "components/background/CurrentUser/BootstrapCurrentUser";
import Metadata from "components/background/Metadata";
import SafeAreaSpacer from "components/shared/SafeAreaSpacer";
import SharedPlaceholders from "components/shared/SharedPlaceholders";
import { useSafeArea } from "hooks/useSafeArea";
import { ReactNode } from "react";
import Providers from "./providers";

export default function GlobalLayout({
                                       children,
                                     }: {
  children: ReactNode;
}) {
  useSafeArea();

  return (
    <Providers>
      <BootstrapCurrentUser/>
      <Metadata/>
      <SafeAreaSpacer/>
      {children}
      <SharedPlaceholders/>
    </Providers>
  );
}
